<script lang="ts">
    import Fa from 'svelte-fa'
    import { faPenNib, faCheck, faTrashAlt, faArrowsAlt, faPlug } from '@fortawesome/free-solid-svg-icons'

    import type { List } from '../../../modules/pipelineApi/pipeline/lists/list'
    import { ListsRepository } from '../../../modules/pipelineApi/pipeline/lists/lists.repository'
    import { ListsService } from '../../../modules/pipelineApi/pipeline/lists/lists.service'
    import type { ListCreateDto } from '../../../modules/pipelineApi/pipeline/lists/lists-create.dto'
    import type { ListUpdateDto } from '../../../modules/pipelineApi/pipeline/lists/lists-update.dto'
    import { createEventDispatcher, onMount } from 'svelte'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    const dispatch = createEventDispatcher()

    export let list: List

    let edit: boolean = false
    let show: boolean = false

    const listR: ListsRepository = new ListsRepository('boards/' + list.boardId + '/lists')
    const listS: ListsService = new ListsService(listR)

    function editEntity() {
        dispatch('edit')
        edit = true
    }

    function saveEntity() {
        if (list.listId) {
            updateEntity()
        } else {
            createEntity()
        }
    }

    async function createEntity() {
        try {
            if (list.label.trim().length === 0) {
                throw new Error('Informe o nome da lista')
            }
            show = true
            const dto: ListCreateDto = {
                label: list.label,
            }
            let result = await listS.create(dto)
            dispatch('change', { detail: result })
            edit = false
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function updateEntity() {
        try {
            if (list.label.trim().length === 0) {
                throw new Error('Informe o nome da lista')
            }
            show = true
            const dto: ListUpdateDto = {
                label: list.label,
            }
            let result = await listS.update(list.listId, dto)
            dispatch('change', { detail: result })
            edit = false
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function removeEntity() {
        if (!list.listId) {
            edit = false
            dispatch('change')
            return
        }
        if (!confirm('Deseja mesmo excluir este registro?')) {
            return
        }
        try {
            show = true
            await listS.remove(list.listId)
            dispatch('change')
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
            edit = false
        }
    }

    onMount(async () => {
        if (!list.listId) {
            edit = true
        }
    })

    function evaluateError(error) {
        window.error(error)
    }

    function integrationLink() {
        dispatch('integration', list)
    }
</script>

<div class="root">
    <div class="input-group input-group-sm">
        <div class="drag">
            <Fa icon={faArrowsAlt} />
        </div>
        <label for="" class="input-group-text">Nome da coluna</label>
        {#if edit}
            <input class="form-control" bind:value={list.label} type="text" />
            <button class="btn btn-sm btn-warning" on:click|stopPropagation={removeEntity}>
                <Fa icon={faTrashAlt} />
            </button>
            <button class="btn btn-sm btn-secondary" on:click|stopPropagation={saveEntity}><Fa icon={faCheck} /></button>
        {:else}
            <input class="form-control" disabled value={list.label + ' / ID: ' + list.listId} type="text" />
            <button class="btn btn-sm btn-secondary" on:click|stopPropagation={integrationLink}>
                <Fa icon={faPlug} />
            </button>
            <button class="btn btn-sm btn-secondary" on:click|stopPropagation={editEntity}>
                <Fa icon={faPenNib} />
            </button>
        {/if}
    </div>
</div>
<LoadSpinner {show} />

<style>
    input:disabled {
        background-color: rgba(var(--background-color), 0.8);
        color: rgb(var(--foreground-color));
        border: 1px solid #99999933;
    }
    .drag {
        border: 0px solid #99999933;
        padding: 0px 6px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .btn {
        min-width: 60px;
    }
</style>
